/*
 * Copyright (c) 2023 Irian Software Development SRL. All Rights Reserved.
 * This software is the proprietary information of Irian Software Development SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Directive, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, Validator, ValidatorFn } from '@angular/forms';
import { ErrorModel } from '../model/error.model';
import { ErrorSeverityEnum } from '../consts/error-severity.enum';

/**
 * @deprecated Use angular required validator
 */
export const customRequiredValidation = (fieldName = ''): ValidatorFn => {
  const funcProperties = {
    field: fieldName,
  };

  return (control: AbstractControl ) => _customRequiredValidation.call(funcProperties, control);
};

/**
 * @deprecated Use angular required validator
 */
function _customRequiredValidation(this: {field: string}, control: AbstractControl): {
  [key: string]: any;
} | null {

  let errors: ErrorModel | null = null;

  if (
    control.value === null ||
    control.value === undefined ||
    control.value.length === 0
  ) {

    errors = {

      severity: ErrorSeverityEnum.error,
      message: 'required' + this.field,
    };
  }

  return errors ? errors : null;
}
